import * as React from 'react';
const StudentIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={props.color}
        d="M6.625 10.75a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75ZM11.5 19H1.75a.75.75 0 0 1-.75-.75v-.375a5.625 5.625 0 0 1 11.25 0v.375a.75.75 0 0 1-.75.75Zm2.625-11.25a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75Zm-1.066 1.516a5.119 5.119 0 0 0-3.502 2.123 7.153 7.153 0 0 1 3.685 3.861h5.008a.75.75 0 0 0 .75-.75v-.028a5.256 5.256 0 0 0-5.94-5.206Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M1 1h18v18H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default StudentIcon;
